import React from 'react';
import { motion } from 'framer-motion';
import { Globe, Award, Star, Zap, Users } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';

const caseIcons = [Globe, Award, Star, Zap, Users];
const caseBadges = ['#D5A63B', '#0F6B49', '#8A9099', '#D5A63B', '#0F6B49'];

const fadeUp = (delay = 0) => ({
  initial: { opacity: 0, y: 30 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true },
  transition: { duration: 0.5, ease: 'easeOut', delay },
});

export default function UseCases() {
  const { t } = useLanguage();
  const uc = t.useCases;

  return (
    <section className="py-14 md:py-20 bg-[#1A222B]" data-testid="use-cases-section">
      <div className="section-container">
        <motion.div className="text-center mb-12" {...fadeUp()}>
          <div className="divider-gold mx-auto" />
          <h2 className="heading-lg">{uc.title}</h2>
        </motion.div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-4">
          {uc.cases.map((c, i) => {
            const Icon = caseIcons[i];
            return (
              <motion.div key={i} className="card-dark p-6" {...fadeUp(0.1 + i * 0.08)}
                data-testid={`use-case-${i}`}>
                <div className="w-10 h-10 rounded-xl flex items-center justify-center mb-4"
                  style={{ backgroundColor: `${caseBadges[i]}20`, border: `1px solid ${caseBadges[i]}30` }}>
                  <Icon size={18} style={{ color: caseBadges[i] }} />
                </div>
                <h3 className="font-exo font-bold italic text-[#F3F1EB] text-base mb-2">{c.title}</h3>
                <p className="text-[#8A9099] text-sm leading-relaxed">{c.desc}</p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
